import { Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import JoesAvatar from "../assets/images/Joes About Picture.jpeg";
const About = () => {
  return (
    <motion.div
      className="container"
      id="aboutheader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Row>
        <Col>
          <h2> About Me </h2>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <br />
          <h4>My name is Jose Garcia</h4>
          <h6>But everyone calls me Joe. I am a south jersey local.</h6>
          <br />
          <p>
            My experience with pressure washing goes back about thirty years
            since I've been helping friends and family get the job done. I
            recently realized that I enjoy what I do and the results I produce.
            So I have decided to started my own business in the trade of
            pressure washing. While I may not have the bells and whisles that my
            competition may offer, I am sweet and simple by only using knowledge
            and equipment that is necessary to do the job right.
          </p>
          <br />
        </Col>
        <Col className="text-center" md={6}>
          <img className="img-thumbnail" src={JoesAvatar} alt="Joe Garcia" />
          <Link to="/contact">
            <Button className="btn-lg mt-3">Get in Touch</Button>
          </Link>
        </Col>
      </Row>
    </motion.div>
  );
};
export default About;
